<template>
  <div class="item__info-table">
    <span>
      <strong>Opdrachtgever(s)</strong>
    </span>
    <span v-if="item.client">
     {{ item.client }}
    </span>
    <span v-else>
      -
    </span>
    <span>
      <strong>Opleverdatum</strong>
    </span>
    <span v-if="item.completion_date">
     {{ item.completion_date }}
    </span>
    <span v-else>
      -
    </span>
    <span>
      <strong>Projectleider</strong>
    </span>
    <span v-if="item.manager">
      {{ item.manager }}
    </span>
    <span v-else>
      -
    </span>
    <div>
      <strong>Deelnemers</strong>
    </div>
    <div>
      <span v-if="projectUsers" class="q-mr-lg">{{ projectUsers }}</span>
      <span v-else>
        -
      </span>
      <q-chip v-if="$can('updateUsers', item.project_id)" outline class="action-chip" icon="add" clickable @click="addUsersDialog = true">
        Wijzigen
      </q-chip>
    </div>
  </div>
  <add-users-dialog v-model="addUsersDialog"
                    :users="users"
                    @update:users="$emit('update:users', $event)"
                    :project-id="item.project_id" />
</template>

<script>
import AddUsersDialog from './dialog/AddUsersDialog'

export default {
  emits: ['update:users'],
  components: {
    AddUsersDialog,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    users: {
      type: Array,
      required: false,
      default: null,
    },
  },
  data () {
    return {
      addUsersDialog: false,
      icon: false,
    }
  },
  computed: {
    projectUsers () {
      if (!this.users) {
        return null
      }

      return this.users.map((user) => {
        return this.$fullName(user)
      }).join(', ')
    },
  },
}
</script>
